import { AxiosResponse } from 'axios';

import { client } from '../client';
import { PresignedURLRequest, PresignedURLResponse } from '../common/types';

import { healthEndPoints } from './endpoints';
import {
  SubmitPortingDocRequest,
  SubmitPortingDocResponse,
  UploadedPortingDocsResponse
} from './types';

export const healthPortingAPIs = {
  getPortingDocumentPresignedURL: (
    policyId: string,
    fileNames: string[]
  ): Promise<AxiosResponse<PresignedURLResponse, PresignedURLRequest>> => {
    return client.post<PresignedURLResponse, PresignedURLRequest>(
      healthEndPoints.getPreSignedURL(policyId),
      { files: fileNames },
      {
        params: {
          path: 'port'
        }
      }
    );
  },
  submitPortingDocument: (
    policyId: string,
    fileName: string
  ): Promise<AxiosResponse<SubmitPortingDocResponse, SubmitPortingDocRequest>> => {
    return client.post<SubmitPortingDocResponse, SubmitPortingDocRequest>(
      healthEndPoints.submitPortingDocument(policyId),
      { key: fileName }
    );
  },
  getUploadedPortingDocumentKeys: (
    policyID: string
  ): Promise<UploadedPortingDocsResponse> =>
    client.get(healthEndPoints.getUploadedPortingDocumentKeys(policyID))
};
